import React from 'react';
import { EnterCredential } from 'new/elements/flows/EnterCredential';
import { FCFormPageType } from 'new/elements/Form/useForm';
import { FORM_TYPE_CREATE_SPARK } from 'js/constants/formTypes';
import useCredentialsPage from 'new/components/flows/controller/useCredentialsPage';
import useSpark from 'new/components/flows/types/spark/useSpark';
import { loadDataCredentials, loadFullVendor } from 'js/actions';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';
import { useDispatch } from 'react-redux';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { GET_ALL_CREDENTIALS_REQUEST, GET_FULL_VENDOR_REQUEST } from 'js/constants/actionTypes';

interface EnterCredentialPageProps {}

export const EnterCredentialPage: FCFormPageType<EnterCredentialPageProps> = (
  props: EnterCredentialPageProps,
) => {
  const { credentialId, selectedConnection, selectedCredentialInfo } = useSpark();
  const dispatch = useDispatch();
  const {
    onSaveCredential,
    onEditCredential,
    onChangeTemplate,
    selectedTemplate,
    onCredentialSelected,
    onCredentialInfoUpdated,
  } = useCredentialsPage({
    useFormData: useSpark,
    formType: FORM_TYPE_CREATE_SPARK,
  });

  const loadCredentialNeeds = () => {
    dispatch(loadFullVendor(selectedConnection));
    dispatch(loadDataCredentials(ACLQueryModeTypes.MODE_COLLABORATOR.key));
  };

  const areCredentialsLoading = useIsLoading(GET_ALL_CREDENTIALS_REQUEST, GET_FULL_VENDOR_REQUEST);

  return (
    <EnterCredential
      reload={loadCredentialNeeds}
      areCredentialsLoading={areCredentialsLoading}
      credentialId={credentialId}
      onCredentialInfoUpdated={onCredentialInfoUpdated}
      onSaveCredential={onSaveCredential}
      onEditCredential={onEditCredential}
      onChangeTemplate={onChangeTemplate}
      selectedTemplate={selectedTemplate}
      selectedCredentialInfo={selectedCredentialInfo}
      onCredentialSelected={onCredentialSelected}
      connectionType={selectedConnection}
    />
  );
};

EnterCredentialPage.formConfig = {
  title: 'Authenticate',
};
